import { type ReactNode } from 'react';
import { DialogBody, DialogFooter, DialogHeader, type DialogHeaderProps, ResponsiveDialog, type ResponsiveDialogProps } from './dialog';
export interface DefaultDialogProps extends ResponsiveDialogProps {
  header?: Omit<DialogHeaderProps, 'onClose'>;
  body?: ReactNode;
  footer?: ReactNode;
}

/**
 * @example
 * overlay.open(({ unmount }) => (
 *  <DefaultDialog
 *    onClose={unmount}
 *    size="xs"
 *    className="h-[500px]"
 *    header={{
 *      title: 'Dialog Header',
 *      hasCloseButton: true,
 *      topSlot: '👋',
 *      leftSlot: (
 *        <IconButton variant="transparent" intent="neutral" size="sm">
 *          <ChevronLeftIcon size="md" />
 *        </IconButton>
 *      ),
 *      rightSlot: (
 *        <IconButton variant="transparent" intent="neutral" size="sm">
 *          <MoreIcon size="md" />
 *        </IconButton>
 *      ),
 *    }}
 *    body={<div>Body</div>}
 *    footer={<div>Footer</div>}
 *    hasDim={false}
 *    shouldCloseOnDimClick={false}
 *  />
 * ));
 */
export const DefaultDialog = ({
  onClose,
  size,
  className,
  header,
  body,
  footer,
  hasDrawerHandle,
  hasDim,
  shouldCloseOnDimClick
}: DefaultDialogProps) => {
  return <ResponsiveDialog onClose={onClose} size={size} className={className} hasDrawerHandle={hasDrawerHandle} hasDim={hasDim} shouldCloseOnDimClick={shouldCloseOnDimClick} data-sentry-element="ResponsiveDialog" data-sentry-component="DefaultDialog" data-sentry-source-file="DefaultDialog.tsx">
      {header && <DialogHeader title={header.title} hasCloseButton={header.hasCloseButton} topSlot={header.topSlot} leftSlot={header.leftSlot} rightSlot={header.rightSlot} onClose={onClose} />}
      {!!body && <DialogBody>{body}</DialogBody>}
      {!!footer && <DialogFooter>{footer}</DialogFooter>}
    </ResponsiveDialog>;
};